import * as React from 'react';
import { ValidationForm, TextInput, SelectGroup, Radio, Checkbox } from 'react-bootstrap4-form-validation';
import * as $ from 'jquery';
import Select from 'react-select';


import { IInstituteList, IDepartmentList } from 'store/StateInterfaces';
// Assets
import '../Assets/CourseEnrolmentForm.sass';

interface IProps {
    addCourse: (data) => boolean;
    loadCoursesListRequest: () => void;
    instituteList: Map<number, IInstituteList>;
    departmentList: Map<number, IDepartmentList>;

};

interface IState {
    institute: any,
    enrollment_type: any,
    department: any,
    anonymity: any,
    notification_toAll: any,
    anonymity_reveal: any,
    title: any,
    courseCode: any,
    image: any,
    course_type: any,
    import_url: any,
    import_file: any,
    archive_import_status: any,
    error_msg: any,
    interval: any,
    selectedInstitute: any,
    selectedDepartment: any,

};
interface IState1 {
    archive_import: any
}
// const CourseEnrolmentForm = (props:IProps) => {
//     $('.custom-file-input').on('change', function() {
//         var fileName = $(this).val().split('\\').pop();
//         $(this).siblings('.custom-file-label').addClass('selected').html(fileName);
//     });

class CourseEnrolmentForm extends React.Component<IProps, IState> {

    constructor(props) {
        super(props);
        this.state = {
            institute: '1',
            enrollment_type: 'O',
            department: '1',
            anonymity: 'partialAnonymous',
            notification_toAll: true,
            anonymity_reveal: true,
            courseCode: '',
            title: '',
            image: '',
            course_type: 'C',
            import_url: null,
            import_file: null,
            archive_import_status: null,
            error_msg: '',
            interval: null,
            selectedInstitute: [{ label: 'Others', value: '1' }],
            selectedDepartment: [{ label: 'Others', value: '1' }],
        }

    }


    handleFileChange = () => {
        var fileName = $(this).val().toString().split('\\').pop();
        $(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    }

    handleCodeChange = (e) => {
        let value = e.target.value;
        if (value.length < 9) {
            $('#courseCodeMessge').text("");
            $('#courseCode').removeClass('bt-warning').removeClass('bt-error');
            this.setState({
                ...this.state,
                [e.target.name]: value,
            });
        }
        else {
            if ($('#courseCode').hasClass("is-invalid")) {
                $("#courseCodeMessge").css("color", "orange");
            }
            else {
                $('#courseCode').addClass('bt-warning').removeClass('bt-error');
            }
            $('#courseCodeMessge').html('Upto 8 characters(alphanumeric and -) are allowed for course code.');
            e.target.value = this.state.courseCode;
        }
    }
    handleChange = (e) => {
        if (e.target.name == 'import_file') {
            this.setState({
                ...this.state,
                [e.target.name]: e.target.files[0]
            });
        } else {
            this.setState({
                ...this.state,
                [e.target.name]: e.target.value,
            });
        }
    }

    handleChangeImage = (e) => {

        var fReader = new FileReader();
        fReader.readAsDataURL(e.target.files[0]);
        fReader.onloadend = function (event) {
            const img: any = document.getElementById("image-id");
            img.src = event.target.result;
        }
        $('#image-name').text(e.target.files[0].name)
        $('.deleteImage').addClass('addInline');

        this.setState({
            ...this.state,
            'image': e.target.files[0]
        });
    }
    selectOptions = (list) => {
        let options = []
        list.forEach(item => {
            options.push({ value: item.id, label: item.name });
        });
        return options;
    }

    handleDeleteImage = (e) => {

        $('#image-name').text('');
        $('.deleteImage').removeClass('addInline');
        $('#image-id').attr("src", "/static/img/upload_image1.png")
        this.setState({
            ...this.state,
            'image': ''
        });
    }
    handleChangeCheckbox = (e, value) => {
        this.setState({
            ...this.state,
            [e.target.name]: value,
        });
        console.log(this.state);
    }
    handleSelectChange = (option, name) => {
        let fieldName = (name == "institute") ? "selectedInstitute" : "selectedDepartment";

        this.setState({
            ...this.state,
            [fieldName]: [option],
            [name]: option.value
        });
    }
    handleSubmit = () => {
    }
    private loadStatus() {
        let url = '/courseware/import_status';
        return fetch(url)
            .then(response => response.json())
            .then(response => {
                if(response["error"]=="AuthenticationError"){
                    window.location.href = `/accounts/login`;
                }
                else{
                    this.setState({ archive_import_status: response['archive_status'], error_msg: response['error'] });
                    if (response['archive_status'] != 'Submitted') {
                        clearInterval(this.state.interval);
                        this.props.loadCoursesListRequest();
                    }
                }
            });
    }
    public componentDidMount() {
        this.loadStatus();
        const interval_ = setInterval(() => {
            this.loadStatus();
        }, 10000);
        this.setState({ interval: interval_ });
    }
    render() {
        let instituteListHTML = [];
        let departmentListHTML = [];
        this.props.instituteList.forEach((institute) => {
            instituteListHTML.push(
                <option value={institute.id} key={institute.id}>{institute.name}</option>
            );
        });

        this.props.departmentList.forEach((department) => {
            departmentListHTML.push(
                <option value={department.id} key={department.id}>{department.name}</option>
            );
        });
        return (
            <div className="modal fade" id="course-enrolment-form" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog" role="form">
                    <div className="modal-content">
                        <div className="closeButton-container">
                            <button type="button" className="closeButton" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        {this.state.archive_import_status == 'not_present' ? (
                            <ValidationForm className='form' encType='multipart/form-data' onSubmit={(e) => { e.preventDefault(); this.props.addCourse(this.state); }}>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className='col-md-8'>
                                            <div className="form-group row">
                                                <label className='col-form-label col-sm-12'>Title</label>
                                                <div className="col-sm-3 courseCode">
                                                    <TextInput name='courseCode' id='courseCode' type='text'
                                                        className='form-control courseCodeInput' required
                                                        pattern="[a-zA-Z0-9-]+"
                                                        placeholder="Course Code"
                                                        onChange={this.handleCodeChange} />
                                                    <div id="courseCodeMessge" className="invalid-feedback"></div>
                                                </div>
                                                <div className="col-sm-9">
                                                    <TextInput name='title' id='title' type='text'
                                                        className='form-control' required
                                                        maxLength={100}
                                                        placeholder="Course Name"
                                                        onChange={this.handleChange} />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="institute">Institute</label>
                                                <Select
                                                    name="institute"
                                                    value={this.state.selectedInstitute}
                                                    className="myInput"
                                                    options={this.selectOptions(this.props.instituteList)}
                                                    onChange={(option) => this.handleSelectChange(option, "institute")}

                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className='col-form-label'>Department</label>

                                                <Select
                                                    name="department"
                                                    value={this.state.selectedDepartment}
                                                    className="myInput"
                                                    options={this.selectOptions(this.props.departmentList)}
                                                    onChange={(option) => this.handleSelectChange(option, "department")}

                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Enrolment Type</label>
                                                <Radio.RadioGroup name="enrollment_type" id="enrollment_type" required errorMessage="Please select enrolment-type" valueSelected={this.state.enrollment_type}
                                                    onChange={this.handleChange} defaultValue="O">
                                                    <Radio.RadioItem id="O" label="Open" value="O" />
                                                    <Radio.RadioItem id="M" label="Moderated" value="M" />
                                                </Radio.RadioGroup>
                                            </div>
                                            <div className="form-group">
                                                <label>Course Content</label>
                                                <Radio.RadioGroup name="course_type" id="course_type" required errorMessage="Please select course-type" valueSelected={this.state.course_type}
                                                    onChange={this.handleChange} defaultValue="C">
                                                    <Radio.RadioItem id="C" label="Create on own" value="C" />
                                                    <Radio.RadioItem id="I" label="Import" value="I" />
                                                </Radio.RadioGroup>
                                            </div>
                                            {this.state.course_type == 'C' ? (<span></span>) :
                                                <div className="form-group row">
                                                    <label className='col-form-label col-sm-12'>Import using File/URL</label>
                                                    <div className="col-sm-5 courseCode">
                                                        <input name='import_file' id='import_file' type='file'
                                                            accept='.tar.gz'
                                                            className='form-control'
                                                            placeholder=".tar.gz"
                                                            ref="imp_fl"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                    <div className="col-sm-1">
                                                        <span><strong>OR</strong></span>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <TextInput name='import_url' id='import_url' type='text'
                                                            className='form-control'
                                                            placeholder="Paste URL here"
                                                            onChange={this.handleChange} />
                                                    </div>
                                                </div>

                                            }
                                            {/* <div className='form-group'>
                                    <label className='col-form-label'>Anonymity</label>
                                    <Radio.RadioGroup name="anonymity" id="anonymity" required errorMessage="Please select anonymity type" valueSelected={this.state.anonymity}
                                        onChange={this.handleChange}>
                                        <Radio.RadioItem id="partialAnonymous" label="Anonymous to class but not to instructor" value="partialAnonymous" />
                                        <Radio.RadioItem id="completeAnonymous" label="Anonymous to all" value="completeAnonymous" />
                                    </Radio.RadioGroup>
                                </div> */}
                                            <div className="form-group">
                                                <label className='col-form-label'>Discussion Forum Settings</label>
                                                <div>
                                                    <Checkbox name="notification_toAll"
                                                        label="Reveal identity of 'anonymous' posts on Discussion Forum to instructor"
                                                        id="notification_toAll"
                                                        value={this.state.notification_toAll}
                                                        onChange={this.handleChangeCheckbox}
                                                    />
                                                    <Checkbox name="anonymity_reveal"
                                                        label="Emails sent to all on every post"
                                                        id="anonymity_reveal"
                                                        value={this.state.anonymity_reveal}
                                                        onChange={this.handleChangeCheckbox}
                                                    />
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className='form-group'>
                                                <label className='col-form-label'>Course Image</label>
                                                <div className='custom-file image-upload'>
                                                    <label htmlFor='file-input'>
                                                        <img className="upload_image_icon" id="image-id"
                                                            src={"/static/img/upload_image1.png"} />
                                                    </label>
                                                    <input id="file-input" name="image" type="file" accept="image/*" onChange={this.handleChangeImage} />
                                                    {/* <input name='image' type='file' className='custom-file-input' id='image'/>
                                        <label className='custom-file-label' htmlFor='image'>Choose file</label> */}
                                                </div>
                                                <div className="image-name">
                                                    <label id="image-name"></label><span className="deleteImage" onClick={this.handleDeleteImage}>&times;</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">Add Course</button>
                                </div>
                            </ValidationForm>) : (this.state.archive_import_status == 'Submitted') ?
                                (<div>
                                    <br></br>
                                    <img className="load-import" src={"/static/img/spin.gif"}></img>
                                    <br></br>&nbsp;
                                    <br></br>
                                    <h6 className="text-center">Import will take time and is in progress in background.<br></br>Click on the Add Course button to check progress.</h6>
                                    <br></br>
                                    <h6 className="text-center"><a href="/courseware/cancel_import">Click here to Cancel the task</a></h6>
                                </div>)
                                : (<div>
                                    <strong><a href="/courseware/cancel_import">Click here to cancel the task</a></strong>
                                    <br></br>&nbsp;
                                    <br></br>
                                    <div><strong>ERROR:</strong></div>
                                    {this.state.error_msg}
                                </div>
                                )
                        }
                    </div>
                </div>
            </div>
        );
    }

};
export default CourseEnrolmentForm;
